"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseTrusted = void 0;
const asyncConnection_1 = require("../../../security/authoriser/helpers/asyncConnection");
class BaseTrusted {
    constructor(api, data, session) {
        this.asyncConnection = undefined;
        this.api = api;
        this.progressId = data.progressId;
        this.data = data;
        this.session = session;
    }
    async init(authoriserInstance) {
        this.asyncConnection = await (0, asyncConnection_1.openAsyncConnection)(authoriserInstance.asyncConnectionMode, this.api, this.session, authoriserInstance.progressId, authoriserInstance.accessToken, this.data, (value) => authoriserInstance.verifyChallenge(value));
    }
    closeAsyncConnection() {
        this.asyncConnection?.disconnect();
        this.asyncConnection = undefined;
    }
    finish() {
        this.closeAsyncConnection();
    }
}
exports.BaseTrusted = BaseTrusted;
//# sourceMappingURL=baseTrusted.js.map